export const translations = {
  text: {
    pt: "Esta página está em processo de homologação.",
    en: "This page is under homologation process.",
    de: "Diese Seite befindet sich im Homologationsprozess.",
    es: "Esta página está en proceso de homologación.",
  },
};
